import FolderViewDialog from './FolderViewDialog';

export default FolderViewDialog;
